import React from 'react'
import { useState } from 'react'
import { connect } from 'react-redux'
import { Item } from '../../common/snippets'
import * as sx from '../../common/stylesInline/report_daily_branch'
import * as id from './common/AcountingId'
import * as lb from './common/AcountingLables'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../common/dropDownOA'
import Datepicker from '../../common/datePicker'
import moment from 'moment'
import { RefreshSvg } from '../../common/svg/refresh'
import { SplitButton } from '../../common/SplitButton'
import { AcountingHeading } from './common/AcountingHeading'
import {
  gstReportColumn,
  gstReportColumnForBoth,
  gstReportColumnFormattedLRNO,
  gstReportSummaryColumnDef,
  nonGstReportColumnDetail,
  viewReport,
} from './common/AcountingConstants'
import { bookingType, gstPaidBy } from '././common/AcountingConstants'
import { paymentModesWithAll } from '../../common/paymentsMode'
import { appendToUrl, diffInMonths, focusElemnt, getInt, isEmpty, navigation3, removeDuplicatesFromArray } from '../../common/helper'
import { getgstReportDetailData, getgstReportFilterData, getgstReportSummaryData } from '../../../store/reports/reports_action'
import { useEffect } from 'react'
import { updateAlertError, updateLoader, updateModal } from '../../../store/common/common_action'
import DetailedTable from './GSTReportV2/DetailedTable'
import ManageColumns from '../../common/ManageColumnsUI'
import SummaryTable from './GSTReportV2/SummaryTable'
import * as URL from '../Reports/oldReportsUrls'
import { urls } from '../../common/constants'
import { GetRequest } from '../../common/api'
import Alert from '../../common/alert'
import { useAtom } from 'jotai'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../helpers/useTokens'
import { CargoRoleRightsAtom, companySettingsAtom } from '../../common/jotaiState/commonStateAtoms'
import { downloadPDF, downloadMultiTablePDF } from '../Reports/analysisReport/pdfAutotable'

const GSTReportV2 = (props) => {
  const {
    data: { common, reports },
    getgstReportFilterData,
    updateAlertError,
    updateModal,
    updateLoader,
  } = props
  const { gstReportFilterData } = reports
  const { showModal, modalType } = common
  const reportName = 'GST Report'
  const [stateList, setStateList] = useState([])
  const [sourceCityList, setSourceCityList] = useState([])
  const [filterSourceCityList, setFilterSourceCityList] = useState([])
  const [sourceBranchList, setSourceBranchList] = useState([])
  const [filterSourceBranchList, setFilterSourceBranchList] = useState([])
  const [destCityList, setDestCityList] = useState([])
  const [destBranchList, setDestBranchList] = useState([])
  const [filterDestBranchList, setFilterDestBranchList] = useState([])
  const [selState, setSelState] = useState([])
  const [selSourceCity, setSelSourceCity] = useState([])
  const [selSourceBranch, setSelSourceBranch] = useState([])
  const [selDestCity, setSelDestCity] = useState([])
  const [selDestBranch, setSelDestBranch] = useState([])
  const [selPayment, setSelPayment] = useState(paymentModesWithAll?.[0])
  const [selGstPaidBy, setSelGstPaidBy] = useState(gstPaidBy[0])
  const [selReportView, setselReportView] = useState(viewReport[1])
  const [selBookingType, setselBookingType] = useState(bookingType[0])
  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [isExpanded, setIsExpanded] = useState(false)
  const [tableData, setTableData] = useState([])
  const [tableDataGST, setTableDataGST] = useState([])
  const [tableDataNonGST, setTableDataNonGST] = useState([])
 
  const [resetFlag, setResetFlag] = useState(false)
  const [resetBranch, setResetBranch] = useState(false)
  const [resetBranch1, setResetBranch1] = useState(false)
  const [resetCity, setResetCity] = useState(false)
  const [disableExcel, setDisableExcel] = useState(false)
  const [disableBtn, setDisableBtn] = useState(false)
  const [showAlert, setShowAlert] = useState({
    show: false,
    message: ''
  })
  
  const [companySettings] = useAtom(companySettingsAtom)
  const [cargoRoleRights] = useAtom(CargoRoleRightsAtom)
  const { Table1: RoleRightTable1 = [] } = cargoRoleRights
  const [roleRightsData] = RoleRightTable1
  let { AllowViewAllBranchOfCityReport, AllowViewAllBranchReport, AllowBranchInchargeRights, AllowExportExcel } = { ...roleRightsData }
  const [searchParams] = useSearchParams()
  const UseFormattedLRinReports = companySettings?.UseFormattedLRinReports || 0

  let { loginData = {} } = useToken()
  let isFromUrl = false
  if (!loginData) {
    loginData = {}
    loginData.intCompanyID = +searchParams.get('C') || 0
    loginData.intBranchCityID = +searchParams.get('CT') || 0
    loginData.strCityName = searchParams.get('CTN') || 0    
    loginData.intBranchID = +searchParams.get('B') || 0
    loginData.strUserName = searchParams.get('UN') || ''
    loginData.strCompanyName = searchParams.get('CN') || ''
    loginData.strBranchName = searchParams.get('BN') || ''
    AllowViewAllBranchOfCityReport = +searchParams.get('AllowViewAllBranchOfCityReport') || 0
    AllowViewAllBranchReport = +searchParams.get('AllowViewAllBranchReport') || 0
    AllowBranchInchargeRights = +searchParams.get('AllowBranchInchargeRights') || 0
    isFromUrl = true
  }
  const { intCompanyID, IsAdmin, intBranchID, intBranchCityID, strCompanyName, strCityName, IsBranchAdmin, strBranchName, IsMTPLAdmin } = loginData  
  
  const headerDataForDetailed = UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1 ? gstReportColumn : UseFormattedLRinReports === 2 ? gstReportColumnFormattedLRNO : gstReportColumnForBoth
  const [manageColumn, setManageColumn] = useState(headerDataForDetailed)
  const selectedFields = manageColumn.filter((item) => item.isSelected).reduce((result, item) => ({ ...result, [item.field]: true }), {})

  const criteriaHeaders = [
    { field: 'fromDate', header: 'From Date', textAlign: 'left' },
    { field: 'toDate', header: 'To Date', textAlign: 'left' },
    { field: 'stateName', header: 'State', textAlign: 'left' },
    { field: 'sourceCity', header: 'Source City', textAlign: 'left' },
    { field: 'sourceBranch', header: 'Source Branch', textAlign: 'left' },
    { field: 'destinationCity', header: 'Destination City', textAlign: 'left' },
    { field: 'destinationBranch', header: 'Destination Branch', textAlign: 'left' },
    { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
    { field: 'gstPaidBy', header: 'GST Paid By', textAlign: 'left' },
    { field: 'bookingType', header: 'Booking Type', textAlign: 'left' },
  ]
  const criteriaData = {
    toDate: moment(toDate).format('DD-MMM-YYYY'),
    fromDate: moment(fromDate).format('DD-MMM-YYYY'),
    stateName: selState.Statename,
    sourceCity: selSourceCity.SourceCity,
    sourceBranch: selSourceBranch.SourceBranch,
    destinationCity: selDestCity.DestinationCity,
    destinationBranch: selDestBranch.DestinationBranch,
    paymentType: selPayment.name,
    gstPaidBy: selGstPaidBy.name,
    bookingType: selBookingType.name,
    dataType: 'entry'
  }
  const handleCloseAlert = () => {
    setShowAlert({ show: false, message: '' })
  }
  useEffect(() => {
    focusElemnt(id.gstFromDate)
  }, [])
  useEffect(() => {
    if (!isEmpty(roleRightsData)) {
      setDisableExcel(!AllowExportExcel)
    }
  }, [roleRightsData])
  useEffect(() => {
    if (!isEmpty(gstReportFilterData)) {
      if (gstReportFilterData?.Data?.Table?.length > 0) {
        let data = []
        let data1 = []
        let data2 = []
        let data3 = []
        let data4 = []
        gstReportFilterData?.Data?.Table?.map((val, i) => {
          data.push({ StateID: val?.StateID, Statename: val?.Statename })
          data1.push({ SourceCityID: val?.SourceCityID, SourceCity: val?.SourceCity, StateID: val?.StateID })
          data2.push({ SourceBranchID: val?.SourceBranchID, SourceBranch: val?.SourceBranch, SourceCityID: val?.SourceCityID })
          data3.push({ DestinationCityID: val?.DestinationCityID, DestinationCity: val?.DestinationCity })
          data4.push({
            DestinationBranchID: val?.DestinationBranchID,
            DestinationBranch: val?.DestinationBranch,
            DestinationCityID: val?.DestinationCityID,
          })
        })
        setStateList([{ Statename: 'All', StateID: 0 }, ...data])
        setSourceCityList([{ SourceCity: 'All', SourceCityID: 0 }, ...data1])
        //filter cityList for city
        setFilterSourceCityList([{ SourceCity: 'All', SourceCityID: 0 }, ...data1])
        setSourceBranchList([{ SourceBranch: 'All', SourceBranchID: 0 }, ...data2])
        //filter branchList for branch
        setFilterSourceBranchList([{ SourceBranch: 'All', SourceBranchID: 0 }, ...data2])
        setDestCityList([{ DestinationCity: 'All', DestinationCityID: 0 }, ...data3])
        setDestBranchList([{ DestinationBranch: 'All', DestinationBranchID: 0 }, ...data4])
        setFilterDestBranchList([{ DestinationBranch: 'All', DestinationBranchID: 0 }, ...data4])
        //deafultValue
        setSelState({
          Statename: gstReportFilterData?.Data?.Table?.filter((obj) => obj.SourceCityID === intBranchCityID)[0]?.Statename,
          StateID: gstReportFilterData?.Data?.Table?.filter((obj) => obj.SourceCityID === intBranchCityID)[0]?.StateID,
        })
        setSelSourceCity({ SourceCity: strCityName, SourceCityID: intBranchCityID })
        setSelSourceBranch({ SourceBranch: strBranchName, SourceBranchID: intBranchID })
        setSelDestCity({ DestinationCity: 'All', DestinationCityID: 0 })
        setSelDestBranch({ DestinationBranch: 'All', DestinationBranchID: 0 })
      } else {
        setStateList([])
        setSourceCityList([])
        setSourceBranchList([])
        setDestCityList([])
        setDestBranchList([])
        setSelState('')
        setSelSourceCity('')
        setSelSourceBranch('')
        setSelDestCity('')
        setSelDestBranch('')
      }
    }
  }, [gstReportFilterData])
  useEffect(() => {
    if (!isEmpty(roleRightsData) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          AllowViewAllBranchReport ||
          AllowBranchInchargeRights ||
          IsBranchAdmin ||
          IsMTPLAdmin ||
          IsAdmin
        )
      )      
    }
  }, [roleRightsData])
  const handleClick2 = () => {
    let url = URL.gstReport
    const urlData = URL.gstReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.dtDateFrom = fromDate.format('YYYY-MM-DD')
    urlData.dtDateTo = toDate.format('YYYY-MM-DD')
    urlData.intStateId = selState.StateID
    urlData.FromCityId = selSourceCity.SourceCityID
    urlData.FromBranchId = selSourceBranch.SourceBranchID
    urlData.ToCityId = selDestCity.DestinationCityID
    urlData.ToBranchId = selDestBranch.DestinationBranchID
    urlData.FromCity = selSourceCity.SourceCity
    urlData.ToCity = selDestCity.DestinationCity
    urlData.FromBranch = selSourceBranch.SourceBranch
    urlData.ToBranch = selDestBranch.DestinationBranch
    urlData.PaymentType = selPayment.typeId
    urlData.strPaymentType = selPayment.name
    urlData.GSTPaidBy = selGstPaidBy.value
    urlData.GstType = selBookingType.id
    urlData.strGstType = selBookingType.value
    urlData.intAllowExportToExcel = 1
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handleClick1 = (isPdf = false) => {
    if (diffInMonths(fromDate, toDate) !== 0) {
      updateAlertError({ show: true, msg: 'Select More Then One Month', nextId: '' })
    } else {
      if (selReportView?.id) {
        const obj = {
          CompanyID: intCompanyID,
          FromDate: fromDate.format('YYYY-MM-DD'),
          ToDate: toDate.format('YYYY-MM-DD'),
          StateID: selState.StateID,
          SourceCityID: selSourceCity.SourceCityID,
          SourceBranchID: selSourceBranch.SourceBranchID,
          DestCityID: selDestCity.DestinationCityID,
          DestBranchID: selDestBranch.DestinationBranchID,
          PaymentType: selPayment.typeId,
          GSTPaidBy: selGstPaidBy.value,
          GstType: selBookingType.id,
        }
        updateLoader(true)
        GetRequest(urls.getgstReportDetailData, obj).then((res) => {
          if (res.status == 'Success') {
            updateLoader(false)
            if (res?.Data?.Table?.length > 0 || res?.Data?.Table1?.length > 0) {
              let tempData = groupData(res)
              let tableDataGST = tempData?.arr1
              let tableDataNonGST = tempData?.arr2
              let reportPayload = []
              let mainHeaderDetailed = manageColumn?.map((val) => ({
                ...val,
                field: val.field,
                align: val.headerSx.textAlign,
                export: val.pdfHead,
                weight: 80,
                width: getInt(val.headerSx.width),
              }))
              let nonGSTHeaderDetailed = nonGstReportColumnDetail?.map((val) => ({
                ...val,
                field: val.field,
                align: val.headerSx.textAlign,
                export: val.pdfHead,
                weight: 80,
                width: getInt(val.headerSx.width),
              }))
              if (selBookingType?.id === 1) {
                reportPayload = {
                  reportName,
                  criteriaHeaders: criteriaHeaders,
                  criteriaData: [criteriaData],
                  tableData: tableDataGST,
                  mainHeader: mainHeaderDetailed,
                  isShowManageColumn: true,
                  manageColumnID: 'creditTransReportColumn',
                  colSpanMarker: 'EwayBillNo',
                  isInvoiceRedirect: true,
                  serialNokey: 'SN',
                }
                if (isPdf === true) {
                  downloadPDF({
                    reportName,
                    criteriaHeaders,
                    criteriaData: [criteriaData],
                    tableData: tableDataGST,
                    visibleColumns: mainHeaderDetailed,
                    loginData,
                    hideHeader: false,
                  })
                  return
                }
              } else if (selBookingType?.id === 2) {
                reportPayload = {
                  reportName,
                  criteriaHeaders: criteriaHeaders,
                  criteriaData: [criteriaData],
                  tableData: tableDataNonGST,
                  mainHeader: nonGSTHeaderDetailed,
                  serialNokey: 'SN',
                }
                if (isPdf === true) {
                  downloadPDF({
                    reportName,
                    criteriaHeaders,
                    criteriaData: [criteriaData],
                    tableData: tableDataNonGST,
                    visibleColumns: nonGSTHeaderDetailed,
                    loginData,
                    hideHeader: false,
                  })
                  return
                }
              } else {
                reportPayload = {
                  reportName,
                  isMultiTable: true,
                  tables: [
                    {
                      reportName: 'GST Booking Detailed',
                      criteriaHeaders: criteriaHeaders,
                      criteriaData: [criteriaData],
                      tableData: tableDataGST,
                      mainHeader: mainHeaderDetailed,
                      // colSpanMarker: 'EwayBillNo',
                      isInvoiceRedirect: true,
                    },
                    {
                      reportName: "Non-GST Booking Detailed",
                      criteriaHeaders: criteriaHeaders,
                      criteriaData: [criteriaData],
                      tableData: tableDataNonGST,
                      mainHeader: nonGSTHeaderDetailed,
                    }
                  ],
                  isShowManageColumn: true,
                  manageColumnID: 'creditTransReportColumn',
                  isClampHeaderToTwoLines: true,
                  isWrapEntryText: true,
                  enableHorizontalScroll: true,
                }
                if (isPdf === true) {
                  downloadMultiTablePDF({
                    reportName,
                    criteriaHeaders,
                    criteriaData: [criteriaData],                    
                    tables: [
                      {
                        reportName: 'GST Booking Detailed',
                        tableData: tableDataGST,
                        visibleColumns: mainHeaderDetailed,
                        hideHeader: false,
                      },
                      {
                        reportName: "Non-GST Booking Detailed",
                        tableData: tableDataNonGST,
                        visibleColumns: nonGSTHeaderDetailed,
                        hideHeader: false,
                      },
                    ],
                    loginData,
                  })
                  return
                }
              }

              const rid = Date.now().toString()
              if (!window.generatedReports) {
                window.generatedReports = {}
              }
              window.generatedReports[rid] = reportPayload
              window.open(`/view-report?rid=${rid}`, "_blank")
            } else {
              setShowAlert({ show: true, message: 'No Data Found!' })
            }
          }
          else {
            updateLoader(false)
            setShowAlert({ show: true, message: res?.ErrMessage })
          }
        }).catch((err) => {
          updateLoader(false)
          console.log('Error:', err)
        })

      } else {
        const obj = {
          CompanyID: intCompanyID,
          FromDate: fromDate.format('YYYY-MM-DD'),
          ToDate: toDate.format('YYYY-MM-DD'),
          StateID: selState.StateID,
          SourceCityID: selSourceCity.SourceCityID,
          SourceBranchID: selSourceBranch.SourceBranchID,
          DestCityID: selDestCity.DestinationCityID,
          DestBranchID: selDestBranch.DestinationBranchID,
          PaymentType: selPayment.typeId,
          GSTPaidBy: selGstPaidBy.value,
          GstType: selBookingType.id,
        }
        updateLoader(true)
        GetRequest(urls.getgstReportSummaryData, obj).then((res) => {
          if (res.status == 'Success') {
            updateLoader(false)
            if (res?.Data?.Table?.length > 0 || res?.Data?.Table1?.length > 0) {
              let tempData = groupData(res)
              let data = [...tempData.arr1, ...tempData.arr2]
              let tableDataGST = tempData?.arr1
              let tableDataNonGST = tempData?.arr2
              let reportPayload = []
              let mainHeaderSummary = gstReportSummaryColumnDef?.map((val) => ({
                ...val,
                field: val.field,
                align: val.headerSx.textAlign,
                export: val.pdfHead,
                weight: 80,
                width: getInt(val.headerSx.width),
              }))
              if (selBookingType?.id === 1) {
                reportPayload = {
                  reportName,
                  criteriaHeaders: criteriaHeaders,
                  criteriaData: [criteriaData],
                  tableData: tableDataGST,
                  mainHeader: mainHeaderSummary,
                }
                if (isPdf === true) {
                  downloadPDF({
                    reportName,
                    criteriaHeaders,
                    criteriaData: [criteriaData],
                    tableData: tableDataGST,
                    visibleColumns: mainHeaderSummary,
                    loginData,
                    hideHeader: false,
                  })
                  return
                }
              }
              else if (selBookingType?.id === 2) {
                reportPayload = {
                  reportName,
                  criteriaHeaders: criteriaHeaders,
                  criteriaData: [criteriaData],
                  tableData: tableDataNonGST,
                  mainHeader: mainHeaderSummary,
                }
                if (isPdf === true) {
                  downloadPDF({
                    reportName,
                    criteriaHeaders,
                    criteriaData: [criteriaData],
                    tableData: tableDataNonGST,
                    visibleColumns: mainHeaderSummary,
                    loginData,
                    hideHeader: false,
                  })
                  return
                }
              } else {
                reportPayload = {
                  reportName,
                  isMultiTable: true,
                  tables: [
                    {
                      reportName: 'GST Booking Summary',
                      criteriaHeaders: criteriaHeaders,
                      criteriaData: [criteriaData],
                      tableData: tableDataGST,
                      mainHeader: mainHeaderSummary,
                    },
                    {
                      reportName: "Non-GST Booking Summary",
                      criteriaHeaders: criteriaHeaders,
                      criteriaData: [criteriaData],
                      tableData: tableDataNonGST,
                      mainHeader: mainHeaderSummary,
                    }
                  ],
                }
                if (isPdf === true) {
                  downloadMultiTablePDF({
                    reportName,
                    criteriaHeaders,
                    criteriaData: [criteriaData],                    
                    tables: [
                      {
                        reportName: 'GST Booking Summary',
                        tableData: tableDataGST,
                        visibleColumns: mainHeaderSummary,
                        hideHeader: false,
                      },
                      {
                        reportName: "Non-GST Booking Summary",
                        tableData: tableDataNonGST,
                        visibleColumns: mainHeaderSummary,
                        hideHeader: false,
                      },
                    ],
                    loginData,
                  })
                  return
                }
              }
              const rid = Date.now().toString()
              if (!window.generatedReports) {
                window.generatedReports = {}
              }
              window.generatedReports[rid] = reportPayload
              window.open(`/view-report?rid=${rid}`, "_blank")
            } else {
              setShowAlert({ show: true, message: 'No Data Found!' })
            }
          }
          else {
            updateLoader(false)
            setShowAlert({ show: true, message: res?.ErrMessage })
          }
        }).catch((err) => {
          updateLoader(false)
          console.log('Error:', err)
        })
      }
    }
  }
  const handleGoClick = () => {
    const obj = {
      CompanyID: intCompanyID,
      FromDate: fromDate.format('YYYY-MM-DD'),
      ToDate: toDate.format('YYYY-MM-DD'),
    }
    getgstReportFilterData(obj)
    focusElemnt(disableBtn ? id.destCity : id.stateId)
  }
  const onSaveColumns = (items) => {
    setManageColumn(items)
    localStorage.setItem('creditTransReportColumn', JSON.stringify(items))
  }
  const handleCityChange = (cityId, type) => {
    if (type === 'SourceCity') {
      if (cityId !== 0) {
        setResetBranch(true)
        const filteredBranches = sourceBranchList.filter((branch) => branch.SourceCityID === cityId)
        const branchListWithAll = [{ SourceBranch: 'All', SourceBranchID: 0 }, ...filteredBranches];
        setFilterSourceBranchList(branchListWithAll)
        setSelSourceBranch({ SourceBranch: 'All', SourceBranchID: 0 })
      } else {
        setFilterSourceBranchList([{ SourceBranch: 'All', SourceBranchID: 0 }, ...sourceBranchList])
        setSelSourceBranch(sourceBranchList[0])
      }
    } else {
      if (cityId !== 0) {
        setResetBranch1(true)
        const filteredBranches = destBranchList.filter((branch) => branch.DestinationCityID === cityId)
        setFilterDestBranchList([{ DestinationBranch: 'All', DestinationBranchID: 0 }, ...filteredBranches])
      } else {
        setFilterDestBranchList([{ DestinationBranch: 'All', DestinationBranchID: 0 }, ...destBranchList])
      }
    }
  }
  const handleStateChange = (stateId) => {
    if (stateId !== 0) {
      setResetCity(true)
      const filteredCities = sourceCityList.filter((branch) => branch.StateID === stateId)
      setFilterSourceCityList([{ SourceCity: 'All', SourceCityID: 0 }, ...filteredCities])
    } else {
      setFilterSourceCityList([{ SourceCity: 'All', SourceCityID: 0 }, ...sourceCityList])
    }
  }
  const groupData = (arr) => {
    let arr1 = []
    let arr2 = []

    arr?.Data?.Table?.map((val) => {
      arr1.push(val)
    })
    arr?.Data?.Table1?.map((val) => {
      arr2.push(val)
    })

    if (selReportView?.id) {
      //DetailTable
      arr1 = arr1?.map((val, i) => ({
        ...val, SN: i + 1, StateName: `${val.StateName}\n${val.ReceiverState}`,
        BookingDateTime: val.BookingDateTime ? moment(val.BookingDateTime).format('DD-MMM-YYYY') : '', BookingGSTInvDate: val.BookingGSTInvDate ? moment(val.BookingGSTInvDate).format('DD-MMM-YYYY') : '', DelGSTInvDate: val.DelGSTInvDate ? moment(val.DelGSTInvDate).format('DD-MMM-YYYY') : '',
        SourceDestCity: `${val.SourceCity}\n${val.DestinationCity}`, dataType: 'entry'
      }))
      arr2 = arr2?.map((val, i) => ({
        ...val, SN: i + 1, StateName: `${val.StateName}\n${val.ReceiverState}`, BookingDateTime: val.BookingDateTime ? moment(val.BookingDateTime).format('DD-MMM-YYYY') : '',
        SourceDestCity: `${val.SourceCity}\n${val.DestinationCity}`, Receiver: `${val.RecName}\n${val.ReceiverGSTN}`, dataType: 'entry'
      }))
      let TotalFreight = 0
      let TotalOtherCharge = 0
      let TotalBookingGst = 0
      let TotalNetAmount = 0
      let TotalBookingGSTAmt = 0
      let TotalBookingCGST = 0
      let TotalBookingSGST = 0
      let TotalBookingIGST = 0
      let TotalDeliveryTaxableAmt = 0
      let TotalDeliveryGST = 0
      let TotalDelGSTAmt = 0
      let TotalDeliveryCGST = 0
      let TotalDeliverySGST = 0
      let TotalDeliveryIGST = 0
      let TotalDeliveryNetAmount = 0
      arr1?.map((val) => {
        TotalFreight += Number(val.Freight)
        TotalOtherCharge += Number(val.OtherCharges)
        TotalBookingGst += Number(val.BookingGst)
        TotalNetAmount += Number(val.NetAmount)
        TotalBookingGSTAmt += Number(val.BookingGSTAmt)
        TotalBookingCGST += Number(val.BookingCGST)
        TotalBookingSGST += Number(val.BookingSGST)
        TotalBookingIGST += Number(val.BookingIGST)
        TotalDeliveryTaxableAmt += Number(val.DeliveryTaxableAmt)
        TotalDeliveryGST += Number(val.DeliveryGST)
        TotalDelGSTAmt += Number(val.DelGSTAmt)
        TotalDeliveryCGST += Number(val.DeliveryCGST)
        TotalDeliverySGST += Number(val.DeliverySGST)
        TotalDeliveryIGST += Number(val.DeliveryIGST)
        TotalDeliveryNetAmount += Number(val.DeliveryNetAmount)
      })
      arr1?.push({
        SourceDestCity: `Total: Booking Type- GST Booking`,
        Freight: TotalFreight?.toFixed(2),
        OtherCharges: TotalOtherCharge?.toFixed(2),
        BookingGst: TotalBookingGst?.toFixed(2),
        NetAmount: TotalNetAmount?.toFixed(2),
        BookingGSTAmt: TotalBookingGSTAmt?.toFixed(2),
        BookingCGST: TotalBookingCGST?.toFixed(2),
        BookingSGST: TotalBookingSGST?.toFixed(2),
        BookingIGST: TotalBookingIGST?.toFixed(2),
        DeliveryTaxableAmt: TotalDeliveryTaxableAmt?.toFixed(2),
        DeliveryGST: TotalDeliveryGST?.toFixed(2),
        DelGSTAmt: TotalDelGSTAmt?.toFixed(2),
        DeliveryCGST: TotalDeliveryCGST?.toFixed(2),
        DeliverySGST: TotalDeliverySGST?.toFixed(2),
        DeliveryIGST: TotalDeliveryIGST?.toFixed(2),
        DeliveryNetAmount: TotalDeliveryNetAmount?.toFixed(2),
        dataType: 'total',
        colSpan: { 'SourceDestCity': 3 },
        align: { 'SourceDestCity': 'left' },

      });

      TotalFreight = 0
      TotalOtherCharge = 0
      TotalNetAmount = 0
      arr2?.map((val) => {
        TotalFreight += Number(val.Freight)
        TotalOtherCharge += Number(val.OtherCharges)
        TotalNetAmount += Number(val.NetAmount)
      })
      arr2?.push({
        Receiver: `Total: Booking Type- Non-GST Booking`,
        Freight: TotalFreight,
        OtherCharges: TotalOtherCharge,
        NetAmount: TotalNetAmount,
        dataType: 'total',
        colSpan: { 'Receiver': 3 },
        align: { 'Receiver': 'right' },
      })

      // arr2?.unshift({
      //   SN: `Report View: Detailed`,
      //   colSpan: { 'SN': 5, 'OtherCharges': 2 },
      //   align: { 'SN': 'left', 'OtherCharges': 'right' },
      //   OtherCharges: `Booking Type: Non-GST Booking`,
      //   dataType: 'subHeader'
      // })
    } else {
      //SummaryTable
      arr1 = arr1?.map((val, i) => ({ ...val, SN: i + 1, dataType: 'entry' }))
      arr2 = arr2?.map((val, i) => ({ ...val, SN: i + 1, dataType: 'entry' }))
      let TotalUnits = 0
      let TotalFreight = 0
      let TotalOtherCharges = 0
      let TotalGST = 0
      let TotalNetAmount = 0
      arr1?.map((val) => {
        TotalUnits += Number(val.Units)
        TotalFreight += Number(val.Freight)
        TotalOtherCharges += Number(val.OtherCharges)
        TotalGST += Number(val.GST)
        TotalNetAmount += Number(val.NetAmount)
      })
      arr1?.push({
        PaymentTypeName: `Total: GST Booking`,
        Units: TotalUnits,
        Freight: TotalFreight,
        OtherCharges: TotalOtherCharges,
        GST: TotalGST,
        NetAmount: TotalNetAmount,
        dataType: 'total'
      })
      TotalUnits = 0
      TotalFreight = 0
      TotalOtherCharges = 0
      TotalGST = 0
      TotalNetAmount = 0
      arr2?.map((val) => {
        TotalUnits += Number(val.Units)
        TotalFreight += Number(val.Freight)
        TotalOtherCharges += Number(val.OtherCharges)
        TotalGST += Number(val.GST)
        TotalNetAmount += Number(val.NetAmount)
      })
      arr2?.push({
        PaymentTypeName: `Total: Non-GST Booking`,
        Units: TotalUnits,
        Freight: TotalFreight,
        OtherCharges: TotalOtherCharges,
        GST: TotalGST,
        NetAmount: TotalNetAmount,
        dataType: 'total'
      })

      // arr1?.unshift({
      //   SN: `Report View : Summary`,
      //   NetAmount: `Booking Type: GST Booking`,
      //   dataType: 'subHeader',
      //   align: { 'SN': 'left', 'NetAmount': 'right' }
      // })
      // arr2?.unshift({
      //   SN: `Report View : Summary`,
      //   NetAmount: `Booking Type: Non-GST Booking`,
      //   dataType: 'subHeader',
      //   align: { 'SN': 'left', 'NetAmount': 'right' }
      // })
    }

    const temp = {
      arr1: arr1,
      arr2: arr2,
    }
    return temp
  }

  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
        {!isFromUrl && <AcountingHeading reportName={reportName} />}
        <Box sx={{ ...sx.reportFlex, justifyContent: 'start', gap: isFromUrl ? '15px' : '10px' }}>
          {!isFromUrl && <>
            <Item sx={sx.itemsx}>
              <DropDownOA
                id={id.selectCompany}
                label={lb.select_company}
                defaultvalue={strCompanyName}
                disabled={true}
                minWidth="250px"
              />
            </Item>
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
                GO
              </Button>
            </Item>
          </>}
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={`From Booking Date`}
              name={'from_date'}
              id={id.gstFromDate}
              value={fromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id.toDate)
              }}
              width={isFromUrl ? '100%' : '210px'}
            />
          </Item>
          <Box sx={{ display: 'flex', flexDirection: 'row', flexWrap: 'nowrap', gap: '10px', width: isFromUrl ? '100%' : 'auto' }}>
            <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
              <Datepicker
                label={'To Booking Date'}
                name={'to_date'}
                id={id.toDate}
                value={toDate}
                dateChange={(date) => {
                  setToDate(date)
                  focusElemnt('goButton')
                }}
                width={isFromUrl ? '100%' : '210px'}
              />
            </Item>
            <Item sx={sx.itemsx} className="disabled-wrapper">
              <Button
                id={'goButton'}
                variant="contained"
                style={{ ...sx.fullHeight, ...sx.novp }}
                className="btn btn-primary"
                onClick={handleGoClick}
                onKeyDown={(e) => navigation3(e, disableBtn ? id.destCity : id.stateId, id.toDate, handleGoClick)}
              >
                GO
              </Button>
            </Item>
          </Box>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.stateId}
              label={'Select State'}
              data={removeDuplicatesFromArray(stateList, 'StateID') || []}
              defaultvalue={selState?.Statename}
              idKey={`StateID`}
              dataKey={`Statename`}
              onSelect={(val) => {
                setSelState(val)
                setIsExpanded(false)
                handleStateChange(val.StateID)
              }}
              isObjArr={true}
              width={isFromUrl ? '100%' : '160px'}
              nextId={id.srcCity}
              prevId={'goButton'}
              resetFlag={resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.srcCity}
              label={'Source City'}
              data={removeDuplicatesFromArray(filterSourceCityList, 'SourceCityID') || []}
              defaultvalue={selSourceCity?.SourceCity}
              idKey={`SourceCityID`}
              dataKey={`SourceCity`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelSourceCity(val)
                handleCityChange(val.SourceCityID, 'SourceCity')
                setResetCity(false)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width={isFromUrl ? '100%' : '160px'}
              nextId={id.srcBranch}
              prevId={id.stateId}
              resetFlag={resetCity || resetFlag}
              disabled={disableBtn}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.srcBranch}
              label={'Source Branch'}
              data={removeDuplicatesFromArray(filterSourceBranchList, 'SourceBranchID') || []}
              defaultvalue={selSourceBranch?.SourceBranch}
              idKey={`SourceBranchID`}
              dataKey={`SourceBranch`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelSourceBranch(val)
                setResetBranch(false)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width={isFromUrl ? '100%' : '250px'}
              nextId={id.destCity}
              prevId={id.srcCity}
              resetFlag={resetBranch || resetFlag}
              disabled={disableBtn && AllowViewAllBranchOfCityReport == 0}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.destCity}
              label={'Destination City'}
              data={removeDuplicatesFromArray(destCityList, 'DestinationCityID') || []}
              defaultvalue={selDestCity?.DestinationCity}
              idKey={`DestinationCityID`}
              dataKey={`DestinationCity`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelDestCity(val)
                handleCityChange(val.DestinationCityID, 'DestinationCity')
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width={isFromUrl ? '100%' : '160px'}
              nextId={id.destBranch}
              prevId={disableBtn ? 'goButton' : id.srcBranch}
              resetFlag={resetFlag}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.destBranch}
              label={'Destination Branch'}
              data={removeDuplicatesFromArray(filterDestBranchList, 'DestinationBranchID') || []}
              defaultvalue={selDestBranch?.DestinationBranch}
              idKey={`DestinationBranchID`}
              dataKey={`DestinationBranch`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelDestBranch(val)
                setResetBranch1(false)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width={isFromUrl ? '100%' : '250px'}
              nextId={id.payType}
              prevId={id.destCity}
              resetFlag={resetBranch1 || resetFlag}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.payType}
              label={'Payment Type'}
              data={paymentModesWithAll || []}
              defaultvalue={selPayment?.name}
              idKey={`typeId`}
              dataKey={`name`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelPayment(val)
              }}
              isObjArr={true}
              width={isFromUrl ? '100%' : '160px'}
              nextId={id.gstPaidBy}
              prevId={id.destBranch}
              resetFlag={resetFlag}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.gstPaidBy}
              label={'GST Paid By'}
              data={gstPaidBy || []}
              defaultvalue={selGstPaidBy?.name}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setIsExpanded(false)
                setSelGstPaidBy(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width={isFromUrl ? '100%' : '160px'}
              nextId={id.bookingType}
              prevId={id.payType}
              resetFlag={resetFlag}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.bookingType}
              label={'Booking Type'}
              data={bookingType}
              defaultvalue={bookingType[0]?.name}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setIsExpanded(false)
                setselBookingType(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search By Report Type`}
              width={isFromUrl ? '100%' : '200px'}
              nextId={id.reportView}
              prevId={id.gstPaidBy}
              resetFlag={resetFlag}
            />
          </Item>
          <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
            <DropDownOA
              id={id.reportView}
              label={lb.reportView}
              data={viewReport}
              defaultvalue={viewReport[1].name}
              idKey={`id`}
              dataKey={`name`}
              onSelect={(val) => {
                setIsExpanded(false)
                setselReportView(val)
              }}
              isObjArr={true}
              searchPlaceholder={`Search Report`}
              width={isFromUrl ? '100%' : '120px'}
              nextId={id.gstSplitButton}
              prevId={id.bookingType}
              resetFlag={resetFlag}
            />
          </Item>
          {isFromUrl ?
            <Button variant="contained" sx={{ width: '100%', height: '40px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id1={id.gstSplitButton}>
              DOWNLOAD PDF
            </Button> :
            <>
              <Item
                sx={sx.itemsx}
                onKeyDown={(e) =>
                  navigation3(
                    e,
                    isExpanded ? (disableExcel ? 'gstExportAsPdfBtn' : 'gstExportToExlbtn') : id.gstFromDate,                    
                    () => handleClick1()
                  )
                }
              >
                <SplitButton
                  options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}                  
                  prevID={id.reportView}
                  id1={id.gstSplitButton}
                  onClick1={handleClick1}
                  onClick2={handleClick2}
                />
              </Item>
              <Item
                sx={{ ...sx.itemsx }}
                onClick={() => {
                  setResetFlag(!resetFlag)
                }}
              >
                <RefreshSvg />
              </Item>
            </>}
        </Box>
      </Item>
      <Item>
        {isExpanded ? (
          selReportView?.id ? (
            <DetailedTable
              tableData={tableData}
              tableDataForGST={tableDataGST}
              tableDataForNonGST={tableDataNonGST}
              loginData={loginData}
              fromDate={fromDate}
              toDate={toDate}
              stateName={selState.Statename}
              sourceCity={selSourceCity.SourceCity}
              sourceBranch={selSourceBranch.SourceBranch}
              destCity={selDestCity.DestinationCity}
              destBranch={selDestBranch.DestinationBranch}
              paymentType={selPayment.name}
              gstPaidBy={selGstPaidBy.name}
              bookingType={selBookingType}
              updateModal={updateModal}
              columns={manageColumn}
              selectedFields={selectedFields}
              disableExcel={disableExcel}
              UseFormattedLRinReports={UseFormattedLRinReports}
            />
          ) : (
            <SummaryTable
              tableData={tableData}
              loginData={loginData}
              fromDate={fromDate}
              toDate={toDate}
              stateName={selState.Statename}
              sourceCity={selSourceCity.SourceCity}
              sourceBranch={selSourceBranch.SourceBranch}
              destCity={selDestCity.DestinationCity}
              destBranch={selDestBranch.DestinationBranch}
              paymentType={selPayment.name}
              gstPaidBy={selGstPaidBy.name}
              bookingType={selBookingType.name}
              disableExcel={disableExcel}
            ></SummaryTable>
          )
        ) : (
          ''
        )}
      </Item>
      {showModal && modalType === 'showManageColumn1' && (
        <ManageColumns headers={manageColumn} onSave={onSaveColumns} updateModal={updateModal} headTxt={`Columns for GST Report`} />
      )}
      {showAlert.show && <Alert msg={showAlert.message} error={true} close={handleCloseAlert} />}
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  getgstReportFilterData,
  getgstReportDetailData,
  getgstReportSummaryData,
  updateAlertError,
  updateModal,
  updateLoader
}
export default connect(mapStateToProps, mapDispatchToProps)(GSTReportV2)
